import { render, staticRenderFns } from "./UploadTarget.vue?vue&type=template&id=10f2cfa6"
import script from "./UploadTarget.vue?vue&type=script&lang=js"
export * from "./UploadTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports